// removed by extract-text-webpack-plugin
module.exports = {"Tag":"_fn7kJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Payment/Common/CommonTag/CommonTag.scss
// module id = 650
// module chunks = 0